<template>
  <div class="constructor-attr-card">
    <div
      class="constructor-attr-row"
      :class="{ 'constructor-attr-focused': focused, 'constructor-attr-deleted': attr.del }"
      @click="$emit('select'); $emit('toggle')"
    >
      <feather-icon
        :icon="expanded ? 'ChevronDownIcon' : 'ChevronRightIcon'"
        size="12"
        class="constructor-attr-toggle"
      />
      <feather-icon
        icon="HashIcon"
        size="12"
        class="constructor-attr-icon"
      />
      <span class="constructor-attr-name">{{ attr.label }}</span>
      <span class="constructor-attr-type">{{ attr.datatype }}</span>
      <span
        v-if="!attr.del"
        class="constructor-attr-del-btn constructor-attr-del-btn--delete"
        title="Пометить на удаление"
        @click.stop="$emit('toggle-delete')"
      >
        <feather-icon
          icon="TrashIcon"
          size="12"
        />
      </span>
      <span
        v-if="attr.del"
        class="constructor-attr-del-btn constructor-attr-del-btn--restore"
        title="Снять пометку удаления"
        @click.stop="$emit('toggle-delete')"
      >
        <feather-icon
          icon="CornerUpLeftIcon"
          size="12"
        />
      </span>
      <span
        v-if="attr.del"
        class="constructor-attr-del-btn constructor-attr-del-btn--remove"
        title="Удалить безвозвратно"
        @click.stop="$emit('remove')"
      >
        <feather-icon
          icon="Trash2Icon"
          size="12"
        />
      </span>
    </div>
    <template v-if="expanded">
      <div
        v-for="(prop, pi) in propKeys"
        :key="prop.key"
        class="constructor-attr-prop"
        :class="{ 'constructor-attr-focused': focusedPropIndex === pi }"
        @click="$emit('select-prop', pi)"
      >
        <span class="constructor-attr-prop-key">{{ prop.key }}: </span>
        <b-form-checkbox
          v-if="prop.editable"
          :checked="prop.val"
          size="sm"
          class="constructor-attr-checkbox"
          @change="$emit('update-field', { field: prop.field, value: $event })"
          @click.native.stop
        />
        <span
          v-else
          class="constructor-attr-prop-val"
        >{{ prop.val }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'CbsConstructorAttrCard',
  components: {
    BFormCheckbox,
  },
  props: {
    attr: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    focusedPropIndex: {
      type: Number,
      default: -1,
    },
    propKeys: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.constructor-attr-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 0;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: #f8f8f8;
  }
}

.constructor-attr-toggle {
  color: #b9b9c3;
  flex-shrink: 0;
}

.constructor-attr-icon {
  color: #b9b9c3;
  flex-shrink: 0;
}

.constructor-attr-name {
  color: #5e5873;
  font-weight: 500;
}

.constructor-attr-type {
  color: #b9b9c3;
  font-size: 12px;
}

.constructor-attr-prop {
  display: flex;
  gap: 8px;
  padding: 1px 0;
  padding-left: 22px;
  font-size: 12px;
  border-radius: 4px;
}

.constructor-attr-prop-key {
  color: #b9b9c3;
  min-width: 30px;
}

.constructor-attr-prop-val {
  color: #6e6b7b;
}

.constructor-attr-checkbox {
  margin: 0;
  padding: 0;
  line-height: 1;

  ::v-deep .custom-control-label {
    &::before,
    &::after {
      top: 0;
      width: 14px;
      height: 14px;
    }
  }
}

.constructor-attr-focused {
  background: rgba(115, 103, 240, 0.08);
  outline: 1px solid rgba(115, 103, 240, 0.3);
}

.constructor-attr-deleted {
  opacity: 0.5;

  .constructor-attr-name,
  .constructor-attr-type {
    text-decoration: line-through;
  }
}

.constructor-attr-del-btn {
  cursor: pointer;
  color: #b9b9c3;
  line-height: 1;
  padding: 2px;
  border-radius: 3px;
  flex-shrink: 0;
  visibility: hidden;

  &:first-of-type {
    margin-left: auto;
  }

  .constructor-attr-row:hover & {
    visibility: visible;
  }
}

.constructor-attr-deleted .constructor-attr-del-btn {
  visibility: visible;
}

.constructor-attr-del-btn--delete:hover {
  color: #ea5455;
  background: rgba(234, 84, 85, 0.1);
}

.constructor-attr-del-btn--restore:hover {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.1);
}

.constructor-attr-del-btn--remove:hover {
  color: #ea5455;
  background: rgba(234, 84, 85, 0.15);
}

// Dark mode
.dark-layout {
  .constructor-attr-row:hover {
    background: #3b4253;
  }

  .constructor-attr-name {
    color: #d0d2d6;
  }

  .constructor-attr-prop-val {
    color: #b4b7bd;
  }

  .constructor-attr-focused {
    background: rgba(115, 103, 240, 0.15);
    outline-color: rgba(115, 103, 240, 0.4);
  }

  .constructor-attr-del-btn {
    color: #4b4b5a;
  }
}
</style>
